import {
  getPlatform,
  isB2B,
  isSpainPlatform,
} from '@/domains/core/settings/utils';

import { KLARNA_LOCALE } from '../constants';

export const useKlarna = () => {
  const showKlarna = !isB2B() && !isSpainPlatform();

  const locale = KLARNA_LOCALE[getPlatform()];

  return {
    showKlarna,
    locale,
  };
};
